import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { CENTRIFUGE_MODULE, VEHICLES_REGISTRY_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, updateLoadParameterReducer,
} from '../../utils/getCrudConfig';
import {
  LOAD_VEHICLE_REGISTRY_BY_ID,
  LOAD_VEHICLE_REGISTRY_LIST,
  LOAD_VEHICLE_REGISTRY_STATUS_HISTORY,
  LOAD_VEHICLE_TRIPS,
  MAP_EVENT,
} from './actions';
import { CENTRIFUGE_PUBLICATION, TRACKING_SUBSCRIBE, SEND_TRACKING_REFRESH } from '../Centrifuge/actions';
import { SUCCESSFUL } from '../../configs/actionNames';
import violations from '../Violations';

const initialState = {
  vehicleRegistryList: [],
  vehicleRegistryListMeta: {},
  loadingVehicleRegistryList: false,
  vehicleTrips: [],
  vehicleTripsMeta: {},
  loadingVehicleTrips: false,
  loadingCurrentVehicleRegistry: false,
  currentVehicleRegistry: {},
  vehicleRegistryStatusHistory: [],
  loadingVehicleRegistryStatusHistory: false,
  vehicleRegistryOnMapList: [],
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST, 'vehicleRegistryList', 'loadingVehicleRegistryList'),
  ...createLoadListReducerWithBegin(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_TRIPS, 'vehicleTrips', 'loadingVehicleTrips'),
  ...updateLoadParameterReducer(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_BY_ID, 'currentVehicleRegistry', 'loadingCurrentVehicleRegistry', {}),
  ...createLoadListReducerWithBegin(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_STATUS_HISTORY, 'vehicleRegistryStatusHistory', 'loadingVehicleRegistryStatusHistory'),
  [CENTRIFUGE_MODULE + TRACKING_SUBSCRIBE + SUCCESSFUL]: (state, action) => {
    const { vehicles = [] } = action.payload;
    return {
      ...state,
      vehicleRegistryOnMapList: vehicles,
    };
  },
  [CENTRIFUGE_MODULE + SEND_TRACKING_REFRESH + SUCCESSFUL]: (state, action) => {
    const { vehicles = [] } = action.payload;
    return {
      ...state,
      vehicleRegistryOnMapList: vehicles,
    };
  },
  [VEHICLES_REGISTRY_MODULE + CENTRIFUGE_MODULE + CENTRIFUGE_PUBLICATION + MAP_EVENT]: (state, action) => {
    const vehicle = action.payload;
    if (!vehicle?.id) {
      return {
        ...state,
      };
    }
    const vehicles = [...state.vehicleRegistryOnMapList];
    const index = vehicles.findIndex(f => f.id === vehicle.id);
    if (index >= 0) {
      vehicles[index] = vehicle;
    }
    if (vehicle?.is_entered && index < 0) {
      vehicles.push(vehicle);
    }
    if (vehicle?.is_left) {
      vehicles.splice(index, 1);
    }
    return {
      ...state,
      vehicleRegistryOnMapList: vehicles,
    };
  },
}, initialState);

export default reducer;

export const getVehicleRegistryData = createSelector(
  [state => state[VEHICLES_REGISTRY_MODULE]],
  state => {
    const {
      vehicleRegistryList,
      loadingVehicleRegistryList,
      vehicleRegistryListMeta,
      loadingCurrentVehicleRegistry,
      currentVehicleRegistry,
      vehicleRegistryStatusHistory,
      loadingVehicleRegistryStatusHistory,
      vehicleRegistryOnMapList,
      vehicleTrips,
      vehicleTripsMeta,
      loadingVehicleTrips,
    } = state;

    return {
      vehicleRegistryList,
      loadingVehicleRegistryList,
      vehicleRegistryListMeta,
      loadingCurrentVehicleRegistry,
      currentVehicleRegistry,
      vehicleRegistryStatusHistory,
      loadingVehicleRegistryStatusHistory,
      vehicleRegistryOnMapList,
      vehicleTrips,
      vehicleTripsMeta,
      loadingVehicleTrips,
    };
  },
);
